// 自动充值并发锁调试接口封装。
// 对应后端 /gradmin/auto-topup-debug/lock 系列接口（GET 查状态 / PUT 预置），
// 供「自动充值并发锁调试」面板调用，让测试同学无需接触 redis-cli / 隧道 / IAM token 即可
// 预置一把「已有充值进行中」的并发锁，做真实前端验证。
// 刻意不提供删除接口：无条件 DEL 可能拆掉测试环境正在跑的真实扣款锁，
// 测完有锁场景后等 TTL 自然过期、或用 Preset 把 ttl_seconds 设短即可。
import request from '@/utils/request';

/** 查询某组织的自动充值并发锁状态 GET /gradmin/auto-topup-debug/lock */
export async function getAutoTopupLock(
  params: { organization_id: string },
  options?: { [key: string]: any }
) {
  return request<any>('/gradmin/auto-topup-debug/lock', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 手动预置一把自动充值并发锁 PUT /gradmin/auto-topup-debug/lock */
export async function putAutoTopupLock(
  params: { organization_id: string },
  body?: { ttl_seconds?: number },
  options?: { [key: string]: any }
) {
  return request<any>('/gradmin/auto-topup-debug/lock', {
    method: 'PUT',
    params,
    data: body || {},
    ...(options || {}),
  });
}
